import React, { useState } from 'react';

const GuessTheYearQuestion = ({ event, onCorrect, onWrong }) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const options = generateOptions(event.year);

  function generateOptions(correctYear) {
    const years = [correctYear];
    while (years.length < 4) {
      const rand = correctYear + Math.floor(Math.random() * 50 - 25);
      if (!years.includes(rand)) years.push(rand);
    }
    return shuffleArray(years);
  }

  function shuffleArray(array) {
    return array.sort(() => Math.random() - 0.5);
  }

  const handleChoice = (year) => {
    if (selectedYear !== null) return;
    setSelectedYear(year);
    if (year === event.year) {
      onCorrect();
    } else {
      onWrong();
    }
  };

  return (
    <div className="text-center">
      <h3 className="text-xl font-bold text-blue-300 mb-4">{event.title}</h3>
      <div className="flex flex-col md:flex-row gap-4 justify-center">
        {options.map((year) => (
          <button
            key={year}
            onClick={() => handleChoice(year)}
            disabled={selectedYear !== null}
            className="bg-gray-800 hover:bg-purple-700 text-white px-6 py-3 rounded-lg font-semibold transition"
          >
            {year}
          </button>
        ))}
      </div>
    </div>
  );
};

export default GuessTheYearQuestion;
